import { AutomateTask, success } from "@iflyrpa/share";
import { DomUtils, parseDocument } from "htmlparser2";
import vm from "vm";
import { errorResponse } from "../../types";
import { Http } from "../../utils/http";
import { type SearchAccountInfoParams } from ".";
import { SearchAccountInfoResponse, wxConfigData } from "./types";

type summaryData = { data_range_type: number; data_value: number }[];
const exportWxCgiData = (
    html: string,
): {
    total_friend_cnt: number;
    new_friend_cnt: number;
    read_summary: summaryData;
    share_summary: summaryData;
} => {
    // 1. 解析 HTML
    const document = parseDocument(html);

    // 2. 找所有 script 标签
    const scripts = DomUtils.findAll((el) => el.type === "script", document.children);

    // 3. 准备 vm 沙箱
    const sandbox: any = {
        window: {},
    };
    sandbox.window.wx = {};
    sandbox.wx = sandbox.window.wx;

    vm.createContext(sandbox);

    // 4. 执行包含 wx.cgiData 的脚本
    for (const script of scripts) {
        const code = DomUtils.textContent(script);

        if (!code) continue;

        if (code.includes("wx.cgiData")) {
            try {
                vm.runInContext(code, sandbox, {
                    timeout: 1000,
                });
            } catch (e) {
                // 非关键脚本可忽略
            }
        }
    }

    // 5. 返回结果
    return sandbox.window.wx.cgiData;
};

export async function getWeixinData(
    _task: AutomateTask,
    params: SearchAccountInfoParams,
): Promise<SearchAccountInfoResponse> {
    const { token } = params;

    if (!token) return { code: 414, message: "缺少token", data: null };

    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        },
    });
    const userInfo = {
        originalCount: 0,
        totalUsers: 0,
        userIncrease: 0,
        yesterday: {
            read: 0,
            share: 0,
            subscribe: 0,
        },
    };
    const userInfoHtmlPromise = http.api<string>({
        method: "get",
        url: "https://mp.weixin.qq.com/cgi-bin/home",
        params: {
            t: "home/index",
            token,
            lang: "zh_CN",
        },
    });
    const userSummaryHtmlPromise = http.api<string>({
        method: "get",
        url: "https://mp.weixin.qq.com/misc/appmsganalysis",
        params: {
            token,
            lang: "zh_CN",
            type: "daily_v2",
            action: "report",
            indicatorSelect: "read",
        },
    });

    const [userInfoHtml, userSummaryHtml] = await Promise.all([userInfoHtmlPromise, userSummaryHtmlPromise]);

    if (userInfoHtml.includes("请重新<a id='jumpUrl' href='/'>登录</a>"))
        return errorResponse("微信公众号数据获取失败，请检查账号状态", 414);

    const userInfoJson = exportWxCgiData(userInfoHtml);
    const userSummaryJson = exportWxCgiData(userSummaryHtml);

    const wxData: wxConfigData = {
        fansNum: userInfoJson.total_friend_cnt,
        fansNumYesterday: userInfoJson.new_friend_cnt,
        readNumYesterday: userSummaryJson.read_summary.filter((it) => it.data_range_type === 1)[0]?.data_value || 0,
        shareNumYesterday: userSummaryJson.share_summary.filter((it) => it.data_range_type === 1)[0]?.data_value || 0,
    };

    return success(wxData, "微信平台数据获取成功！");
}
